import Vue from "vue"

export default Vue.extend({
  layout: "login",
  auth: "guest",
})
